<template>
<div>
    <md-dialog-content>
        <p>Create Your Project</p>
        <md-input-container>
            <label>Project Name</label>
            <md-input required v-model="project.title"></md-input>
        </md-input-container>
        <md-input-container>
            <label>File</label>
            <md-file required @selected="onFileChange"></md-file>
        </md-input-container>
    </md-dialog-content>
</div>      
</template>

// TODO disable Continue button while prject name is blank.

<script>
const Create = {
    name: 'create',
    props: ['project'],
    methods: {
        onFileChange: function(fileList) {
            this.project.fileObject = fileList[0];
        }
    }
    // components: {
    //  'core-nav-main': CoreNavMain
    // }
};
export default Create;
</script>

<style>
</style>


// WEBPACK FOOTER //
// create.vue?5f3f195b